import deepmerge from "deepmerge";

import { DeepPartial } from "../../../../../../../Common/TypingUtils";

import { ThemeColor } from "./ThemeColor";
/**
 * https://guides.kontur.ru/principles/color/#Chernii,_belii,_serii
 */
export interface IBlackAndWhiteTokens {
    /**
     * Фон для зоны контента
     */
    primaryBackgroundColor: ThemeColor;

    /**
     * Фон для блоков, боковой панели, меню второго уровня
     */
    panelBackgroundColor: ThemeColor;
    panelBackgroundColorAsBlackTransparent: ThemeColor;
    panelSecondaryColor: ThemeColor;

    /**
     * Фон сервиса, плашки лайтбокса, выбранный пункт списка
     * https://guides.kontur.ru/principles/color/#Chernii,_belii_i_serii
     */
    panel2BackgroundColor: ThemeColor;
    panel2BackgroundColorAsBlackTransparent: ThemeColor;

    /**
     * Цвет футера для встроенных форм в кевебе , например ion
     */
    panel3BackgroundColor: ThemeColor;

    /**
     * Цвет разделительной линии
     * https://guides.kontur.ru/principles/color/#09
     */
    dividerColor: ThemeColor;

    /**
     * Неактивный текст, ватермарк, доп. иконка
     */
    inactiveTextColor: ThemeColor;

    /**
     * Дополнительный текст
     */
    secondaryTextColor: ThemeColor;

    /**
     * Текст и иконки на белом фоне
     */
    primaryTextColor: ThemeColor;

    /**
     * https://guides.kontur.ru/principles/color/#13
     */
    invertedColors: {
        backgroundColor: ThemeColor;
        hoveredColor: ThemeColor;
        color: ThemeColor;
        inactiveColor: ThemeColor;
    };
}

/**
 * https://guides.kontur.ru/principles/color/#Firmennie_tsveta
 */
export interface IBrandTokens {
    /**
     * Основной цвет
     */
    primaryColor: ThemeColor;
    /**
     * Плашка
     */
    panelColor: ThemeColor;
}

/**
 * https://guides.kontur.ru/principles/color/#Smislovie_tsveta
 */
export interface ISemanticTokens {
    action: {
        backgroundColor: ThemeColor;
        alternativeColor: ThemeColor;
        iconColor: ThemeColor;
        color: ThemeColor;
    };
    danger: {
        backgroundColor: ThemeColor;
        alternativeColor: ThemeColor;
        iconColor: ThemeColor;
        color: ThemeColor;
    };
    warning: {
        backgroundColor: ThemeColor;
        alternativeColor: ThemeColor;
        iconColor: ThemeColor;
        color: ThemeColor;
    };
    success: {
        backgroundColor: ThemeColor;
        alternativeColor: ThemeColor;
        iconColor: ThemeColor;
        color: ThemeColor;
    };
}

export interface IThemeTokens {
    colors: {
        blackAndWhite: IBlackAndWhiteTokens;
        semantic: ISemanticTokens;
        brand: IBrandTokens;
    };
    type: {};
    spacing: {};
}

export function overrideThemeTokens(primary: IThemeTokens, override: DeepPartial<IThemeTokens>): IThemeTokens {
    // @ts-expect-error Тупая там дефиниция
    return deepmerge(primary, override);
}
